import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  standalone: true,
  imports: [
    ModalContainerComponent
  ]
})
export class ModalConfirmComponent implements OnInit {
  @Output() confirm = new EventEmitter();
  
  @ViewChild('modalContainer') modalContainer!: ModalContainerComponent;
  
  constructor() { }
  
  ngOnInit() {
  }
  
  openModal() {
    this.modalContainer.openModal();
  }
  
  onCancel() {
    this.modalContainer.close();
  }
  
  onConfirm() {
    this.confirm.emit();
    this.modalContainer.close();
  }

}
